import type { CustomFieldDefinition, CustomFieldDefinitions, CustomFieldTexts } from '../schema/customFields';
import { intFromMixed } from './coerce';

/** Component-level `customFields: { options: {…}, choices: {…} }`. */
export function parseCustomFieldDefinitions(raw: unknown): CustomFieldDefinitions {
    const r = (raw ?? {}) as Record<string, unknown>;
    return { characteristics: definitionList(r.options), values: definitionList(r.choices) };
}

function definitionList(raw: unknown): CustomFieldDefinition[] {
    if (!raw || typeof raw !== 'object') return [];
    const out: CustomFieldDefinition[] = [];
    for (const [key, def] of Object.entries(raw as Record<string, unknown>)) {
        const d = (def ?? {}) as Record<string, unknown>;
        const id = intFromMixed(d.id ?? key, 0);
        if (!id || typeof d.name !== 'string') continue;
        out.push({ id, name: d.name, type: typeof d.type === 'string' ? d.type : 'text' });
    }
    return out.sort((a, b) => a.id - b.id);
}

/** Per Characteristic / Value: `customFields: { "<field id>": { value } }`. */
export function parseCustomFieldTexts(raw: unknown): CustomFieldTexts {
    if (!raw || typeof raw !== 'object') return {};
    const out: Record<string, string> = {};
    for (const [key, entry] of Object.entries(raw as Record<string, unknown>)) {
        const v = entry && typeof entry === 'object' ? (entry as Record<string, unknown>).value : undefined;
        if (typeof v === 'string') out[key] = v;
        else if (typeof v === 'number') out[key] = String(v);
    }
    return out;
}
